import loading from '../../../../../assets/images/loading.svg';


function Loader() {
  return (
      <div className="loaderOuterDiv">
        <div className="loaderDiv">
          <img src={loading} className="loaderImg" />
        </div>
      </div>

  );
}

export default Loader;